

import { defineComponent } from "vue";
export default defineComponent({

    computed: {
        forbidden() {
            return require('@/access-denied.svg').default;
        }
    }
})

